/**
 * Endkundenrechner API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Platz eines Tarifs im Vorschlagsraster - der günstigste, der bestbewertete oder der mittlere.
 */
export enum OfferSlot {

    Guenstigster = 'Guenstigster',

    Mittlerer = 'Mittlerer',

    Bester = 'Bester'
}

